const modules = {}
const requireModule = require.context('./', false, /.js$/)

requireModule.keys().forEach(fileName => {
  if (fileName === './index.js') return
  modules[fileName.slice(2, -3)] = requireModule(fileName).default
})
export default { namespaced: true, modules }
